export enum MutationTypes {
  SET_REPORTS = "reports-module/set-reports",
  SET_REPORTS_META = "reports-module/set-reports-meta",
  SET_REPORT = "reports-module/set-report",
  SET_PDF = "reports-module/set-pdf",
  SET_REPORTS_FOR_CSV = "reports-module/set-reports-for-csv",
}
